import { FC, useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { BookingMessageForm } from './BookingMessageForm';
import { routes } from '../../../../utils/constants/routes';
import { URLS } from '../../../../utils/constants/urls';
import axiosInstance from '../../../../utils/axios';
import AddEdit from '../../CommonPage/AddEdit';
import strings from '../../../../common/Translation/Translate';
import LanguageDrodownValue from '../../../../utils/hooks/LanguageDrodownValue';

const AddEditBookingMessage: FC = () => {
  const { id } = useParams() as any;
  const languageList = LanguageDrodownValue() as any;
  const [pageResponse, setPageResponse] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const getPageData = useCallback(async () => {
      try {
        setLoading(true);
        const { data } = await axiosInstance.get(URLS.get_edit_bookingMessagesId(id));
        const container: any = {};
        for (let i = 0; i < languageList?.length; ++i) {
          let values = ['editor_' + languageList[i]?.value];
          container[values as any] = data.localizedAttributes[languageList[i]?.value]
            ? data.localizedAttributes[languageList[i]?.value].template
            : '';
        }
        setPageResponse(container);
      } catch (error: any) {
      } finally {
        setLoading(false);
      }
    },
    [id, languageList],
  );

  useEffect(() => {
    (async () => {
      if (id) {
        await getPageData();
      }
    })();
  }, [getPageData, id]);

  const handleSetModel = useCallback(() => {
    const newArray = [] as any;
    languageList.forEach((language: any) => {
        const newObject = { ...BookingMessageForm(strings)[0] };
        newObject.field = 'editor_' + language.value;
        newObject.label = newObject.label + ' (' + language.text + ')';
        newArray.push(newObject);
      },
    );
    return newArray;
  }, [languageList]);

  useEffect(() => {
    handleSetModel();
  }, [handleSetModel]);


  const pageConfig =
    {
      title: strings.bookingMessage_title_list,
      successMessage: strings.common_update_message,
      addEditApiUrl: URLS.get_edit_bookingMessagesId(id),
      formModel: handleSetModel(),
      navigateToPage: routes.bookingMessage,
      isCustomResponse: true,
    };

  const handleCustomResponse = (custom: any) => {
    const localizedAttributes = [] as any;
    languageList?.map((item: { text: string, value: string }) =>
      localizedAttributes.push({
        language: item.value,
        template: custom['editor_' + item.value],
      }),
    );
    return { localizedAttributes: localizedAttributes };
  };
  return (<AddEdit
    pageConfig={pageConfig} pageResponse={pageResponse} handleCustomResponse={handleCustomResponse}
    pageLoading={loading} />);
};
export default AddEditBookingMessage;
